export default "__VITE_ASSET__Blpr6So0__"